// @ts-nocheck

/**
 * * `PENDING` - PENDING
 * `GENERATING` - GENERATING
 * `COMPLETE` - COMPLETE
 * `ERROR` - ERROR
 */
export type StoryGenerationResponseStatusEnum =
  typeof StoryGenerationResponseStatusEnum[keyof typeof StoryGenerationResponseStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StoryGenerationResponseStatusEnum = {
  PENDING: "PENDING",
  GENERATING: "GENERATING",
  COMPLETE: "COMPLETE",
  ERROR: "ERROR",
} as const;
